export default "__VITE_ASSET__CV_z0eGe__"